export const PRODUCT_CREATE_RESET = 'PRODUCT_CREATE_RESET'
export const PRODUCT_CREATE_SET_CREATED = 'PRODUCT_CREATE_SET_CREATED'
export const PRODUCT_CREATE_SET_ERROR = 'PRODUCT_CREATE_SET_ERROR'
export const PRODUCT_CREATE_SET_VIOLATIONS = 'PRODUCT_CREATE_SET_VIOLATIONS'
export const PRODUCT_CREATE_TOGGLE_LOADING = 'PRODUCT_CREATE_TOGGLE_LOADING'
